var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.value)?_c('v-icon',{attrs:{"color":"success"}},[_vm._v(" "+_vm._s(_vm.iconSuccess)+" ")]):_c('v-icon',{attrs:{"color":"error"}},[_vm._v(" "+_vm._s(_vm.iconFailed)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }